'use strict';

exports.__esModule = true;
exports.default = useScroll;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ScrollBehaviorContext = require('./ScrollBehaviorContext');

var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScroll() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Support the old configuration format where
  // shouldUpdateScroll is the only argument
  var shouldUpdateScroll = typeof options === 'function' ? options : options.shouldUpdateScroll;

  var updateScroll = options.updateScroll || function (cb) {
    return cb();
  };

  return {
    renderRouterContext: function renderRouterContext(child, props) {
      return _react2.default.createElement(
        _ScrollBehaviorContext2.default,
        {
          shouldUpdateScroll: shouldUpdateScroll,
          updateScroll: updateScroll,
          routerProps: props
        },
        child
      );
    }
  };
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-scroll-async/lib/useScroll.js
 ** module id = 1282
 ** module chunks = 1
 **/